import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  CIF: [],
};

const CIFSlice = createSlice({
  name: "CIF",
  initialState,
  reducers: {
    updateCIF: (state, action) => {
      const index = state.CIF.findIndex(
        (item) => item.country === action.payload.country
      );
      if (index !== -1) {
        state.CIF[index] = action.payload;
      } else {
        state.CIF.push(action.payload);
      }
    },
  },
});

export const { updateCIF } = CIFSlice.actions;

export default CIFSlice.reducer;
